import type { CategoryKey } from "@/mocks/stories";

export interface CatStyle {
  badge: string;
  dot: string;
  chip: string;
}

export const catStyles: Record<CategoryKey, CatStyle> = {
  dorm: {
    badge: "bg-primary-100 text-primary-800",
    dot: "bg-primary-500",
    chip: "bg-primary-500 text-white",
  },
  classroom: {
    badge: "bg-accent-100 text-accent-900",
    dot: "bg-accent-500",
    chip: "bg-accent-500 text-white",
  },
  desk: {
    badge: "bg-secondary-100 text-secondary-800",
    dot: "bg-secondary-500",
    chip: "bg-secondary-500 text-white",
  },
  chat: {
    badge: "bg-background-200 text-foreground-700",
    dot: "bg-foreground-500",
    chip: "bg-foreground-800 text-white",
  },
  gossip: {
    badge: "bg-primary-50 text-primary-700 border border-primary-200",
    dot: "bg-primary-300",
    chip: "bg-background-900 text-white",
  },
};

export const catNameMap: Record<CategoryKey, string> = {
  dorm: "宿舍迷惑",
  classroom: "课堂社死",
  desk: "同桌奇葩",
  chat: "群聊翻车",
  gossip: "课间八卦",
};